import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { RegisterEditCrubs } from 'practice/constants/practice-register-crubs';
import FormRegister, { FormRegisterVM } from 'practice/components/register/form';
import { useNavigate, useParams } from 'react-router-dom';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeRegisterData } from 'shell/models/practice-lists';
import { registerResponseTransformer } from 'practice/utils/metric-register-transformer';

const EditRegister = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-registro');
  });

  const [register] = useHttpFetch<HttpResponse<TypeRegisterData>, FormRegisterVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-registro/${params?.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: registerResponseTransformer,
    }
  );

  const updateRegister = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-registro/`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormRegisterVM) => {
      (
        updateRegister({
          data: {
            descrizioneRegistro: values.description,
            key: {
              tipoRegistro: values.type,
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-registro');
      });
    },
    [navigate, updateRegister]
  );

  return (
    <Fragment>
      <Breadcrumbs items={RegisterEditCrubs} />
      {register.isLoading || register.pristine || register.hasErrors ? undefined : (
        <FormRegister
          title="Modifica Registro"
          onCancel={onCancel}
          isEdit
          initialValues={register?.data as FormRegisterVM}
          onSubmit={onSubmit}
        />
      )}
    </Fragment>
  );
};

EditRegister.displayName = 'Edit Register Page component';

export default EditRegister;
